import React from 'react';
import ArrowDown from "../../assets/images/chatbot/ArrowDown.svg";
import ArrowUp from "../../assets/images/chatbot/ArrowUp.svg";
import { ImageUrl } from '../../utils/chatbotHelper';

function Header(props) {
    const { isMinimized, toggleMinimize } = props;
    return (
        <header className='header cursor-pointer' onClick={() => toggleMinimize()}>
            <div className='header__avtar--container'>
                <img alt="bot-icon" src={ImageUrl} />
                <span>Ask <span className="semi-bold">Pihu!</span></span>
            </div>
            <div className='header__action--container'>
                <button className='button header__action cursor-pointer' ><img src={isMinimized ? ArrowUp : ArrowDown} /></button>
            </div>
        </header>
    )
}

export default Header